import React from "react";
import { FormField } from "@/shared/components/FormField";
import DynamicOptionsField from "@/shared/components/DynamicOptionsField";
import { CoverageSettings, SimpleOption } from "@/shared/types/Quote.interface";

export type CoverageLevel = "accidentOnly" | "accidentAndIllness";
export type FloatingVariant = "default" | "floating" | "floating-inner" | "icon";

interface CoverageTypeControlProps {
    coverageTypes?: SimpleOption[];
    coverageLevel: CoverageLevel;
    onCoverageLevelChange: (level: CoverageLevel, draftCoverageSettings?: CoverageSettings) => void;
    floatingVariant?: FloatingVariant;
}

export const CoverageTypeControl: React.FC<CoverageTypeControlProps> = props => {
    const { coverageTypes, coverageLevel, onCoverageLevelChange, floatingVariant } = props;

    if (!coverageTypes || coverageTypes.length < 1) {
        return null;
    }

    const testableOptions = coverageTypes.map(opt => ({
        ...opt,
        id: opt.value === "accidentOnly" ? "toggle-accident-only" : opt.value === "accidentAndIllness" ? "toggle-accident-illness" : opt.value
    }));

    return (
        <FormField>
            <DynamicOptionsField
                variant={floatingVariant}
                id="coverage-type"
                options={testableOptions}
                label="Coverage"
                labelStyles="hidden"
                initialValue={coverageLevel}
                constrainWidthToTrigger={true}
                onValueChange={value => onCoverageLevelChange(value as any)}
            />
        </FormField>
    );
};
